module.exports = __webpack_public_path__ + "img/w3_circle_filter_black.d637af78.png";